import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Grid, Stack } from "@mui/material";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { addMinutes, format, hoursToMinutes, secondsInHour } from "date-fns";

import { ShiftCardWrapper } from "../../Shift/Card/Wrapper";
import { formatToHoursAndMinutes } from "../../utils/formatToHoursAndMinutes";
import { VisitCardContentWrapper } from "../Card/ContentWrapper";
import { VisitPricingTypes } from "../constants";
import { type VisitOccurrenceData } from "../types";
import { VisitOccurrencesStatusPill } from "./StatusPill";

interface VisitOccurrencesCardProps {
  visitOccurrence: VisitOccurrenceData;
}

export function VisitOccurrencesCard(props: VisitOccurrencesCardProps) {
  const { visitOccurrence } = props;
  const { estimatedDuration, completedAt, status, pricingType } = visitOccurrence.attributes;
  const visitOccurrenceStartTime = new Date(completedAt);
  const visitOccurrenceEndTime = addMinutes(
    visitOccurrenceStartTime,
    hoursToMinutes(estimatedDuration ?? 0)
  );

  return (
    <ShiftCardWrapper sx={{ width: "100%", minHeight: "auto" }}>
      <VisitCardContentWrapper>
        <Stack direction="row" spacing={5} justifyContent="space-between" alignItems="baseline">
          <VisitOccurrencesStatusPill status={status} />
          {isDefined(estimatedDuration) && pricingType === VisitPricingTypes.PER_HOUR && (
            <Text semibold variant="body1">
              {formatToHoursAndMinutes(estimatedDuration * secondsInHour)}
            </Text>
          )}
        </Stack>

        {/* Start time Row */}
        <Grid container alignItems="baseline">
          <Grid item xs={1.5}>
            <Text semibold color={(theme) => theme.palette.text.tertiary} variant="caption">
              Start
            </Text>
          </Grid>
          <Grid item xs={3}>
            <Text variant="body2">{format(visitOccurrenceStartTime, "eee, MMM d")}</Text>
          </Grid>
          <Grid item xs={7.5} display="flex" justifyContent="flex-end">
            <Text variant="body2">{format(visitOccurrenceStartTime, "h:mm a")}</Text>
          </Grid>
        </Grid>

        {/* End time Row */}
        {isDefined(estimatedDuration) && pricingType === VisitPricingTypes.PER_HOUR && (
          <Grid container alignItems="baseline">
            <Grid item xs={1.5}>
              <Text semibold color={(theme) => theme.palette.text.tertiary} variant="caption">
                End
              </Text>
            </Grid>
            <Grid item xs={3}>
              <Text variant="body2">{format(visitOccurrenceEndTime, "eee, MMM d")}</Text>
            </Grid>
            <Grid item xs={7.5} display="flex" justifyContent="flex-end">
              <Text variant="body2">{format(visitOccurrenceEndTime, "h:mm a")}</Text>
            </Grid>
          </Grid>
        )}
      </VisitCardContentWrapper>
    </ShiftCardWrapper>
  );
}
